/*
 * @Descripttion: 这是主文件
 * @version: 
 * @Author: 123
 * @Date: 2023-11-02 14:51:54
 * @LastEditors: 123
 * @LastEditTime: 2025-09-18 14:33:32
 */
import { createApp } from 'vue'
import App from './App.vue'
import 'amfe-flexible'
import 'normalize.css'
import router from './router'
import store from './store'
import { setSessionStorage } from './utils/auth'
import ElementPlus from 'element-plus'
// import 'element-plus/dist/index.css'
import { registerGlobComp } from './components/registerGlobComp'
import './icons' // icon
import './permission' // permission control/
import '@/style/index.scss' // global css
// 引入 cornerstone,dicomParser,cornerstoneWADOImageLoader
import * as cornerstoneWebImageLoader from "cornerstone-web-image-loader";
import * as cornerstoneWADOImageLoader from '../static/dist/cornerstoneWADOImageLoader.js'
import * as cornerstone from 'cornerstone-core-mzyl'
import * as dicomParser from 'dicom-parser'
import Hammer from 'hammerjs'
import * as cornerstoneTools from 'cornerstone-tools-mzyl'
import * as cornerstoneMath from 'cornerstone-math'

const app = createApp(App)
// Register global components
registerGlobComp(app)
// app 初始化
function appInit () {
  // 获取二维码参数
  const selfUrlParams = (function (href) {
    let url = '?' + href.split('?')[1]
    url = url.split('#')[0]
    const thisParam = {}
    if (url.indexOf('?') !== -1) {
      var str = url.substr(1)
      var strs = str.split('&')
      for (var i = 0; i < strs.length; i++) {
        thisParam[strs[i].split('=')[0]] = decodeURI(strs[i].split('=')[1])
      }
    }
    return thisParam
  })(
    window.location.href
  )
  const { sign } = selfUrlParams
  if (!sign) {
    // router.push('/permission')
  }
  if (sign) {
    // 设置缓存
    setSessionStorage('urlParams', selfUrlParams)
  }

  cornerstoneInit()
}
function cornerstoneInit () {
  cornerstoneWebImageLoader.external.cornerstone = cornerstone;
  cornerstoneWADOImageLoader.external.cornerstone = cornerstone
  cornerstoneTools.external.cornerstone = cornerstone

  cornerstoneTools.external.Hammer = Hammer
  cornerstoneTools.external.cornerstoneMath = cornerstoneMath
  cornerstoneWADOImageLoader.external.cornerstoneMath = cornerstoneMath
}

console.log(`%c当前运行的前端${'V3.0.0.0033'}`, 'color: #0971faa1;font-size: 16px;font-weight: bold;text-decoration: underline;');


app.use(store).use(router).use(ElementPlus).use(cornerstone).use(dicomParser).use(cornerstoneTools).use(cornerstoneWADOImageLoader)
app.mount('#app')

appInit()
